<template>
  <div class="loader">
    <div class="loading-bar">
      <div class="loading-bar__fill"></div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped lang="scss" type="text/scss">
.loader {
  display: flex;
  min-height: 100%;
  justify-content: center;
  align-items: center;
}

.loading-bar {
  position: relative;
  margin: auto;
  height: .5em;
  width: 6em;
}

.loading-bar__fill,
.loading-bar__fill:before,
.loading-bar__fill:after {
  position: relative;
  background: $color-white;
  height: .25em;
  width: 6em;
  animation-name: loading-bar;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  box-shadow: 0 0 $color-white;
}

.loading-bar__fill:before,
.loading-bar__fill:after {
  left: 0;
  position: absolute;
  content: '';
}

.loading-bar__fill {
  animation-delay: .12s;
}

.loading-bar__fill:before {
  transform: translateY(-1em);
}

.loading-bar__fill:after {
  transform: translateY(1em);
  animation-delay: .24s;
}

@keyframes loading-bar {
  0% {
    width: 6em;
    box-shadow: 0 0 $color-white;
  }

  50% {
    width: 8em;
    box-shadow: -2em 0 $color-white; // The difference between the widths.
  }
}
</style>